"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskStatusColor = void 0;
const react_1 = require("react");
const useStateNodeByStatus_1 = require("../../hooks/useStateNodeByStatus");
const useParseTaskStatus_1 = require("./useParseTaskStatus");
const useTaskWorkflow_1 = require("./useTaskWorkflow");
function useTaskStatusColor(props) {
    var _a;
    const { task, getLabel } = props;
    // get status from task or task log (props.status)
    const status = props.status || (task === null || task === void 0 ? void 0 : task.status) || '';
    const workflow = (0, useTaskWorkflow_1.useTaskWorkflow)(task);
    const stateNode = (0, useStateNodeByStatus_1.useStateNodeByStatus)(status, workflow);
    const taskStatus = (0, useParseTaskStatus_1.useParseTaskStatus)(status || (stateNode === null || stateNode === void 0 ? void 0 : stateNode.name) || '');
    const stateColor = (_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.meta) === null || _a === void 0 ? void 0 : _a.color;
    const color = stateColor && typeof stateColor === 'object'
        ? stateColor
        : { color: '#333', background: '#efefef' };
    const label = (0, react_1.useMemo)(() => {
        const label = taskStatus || 'Unknown Status';
        return (getLabel === null || getLabel === void 0 ? void 0 : getLabel(label)) || label;
    }, [getLabel, taskStatus]);
    return { color, label };
}
exports.useTaskStatusColor = useTaskStatusColor;
//# sourceMappingURL=useTaskStatusColor.js.map